/* import __COLOCATED_TEMPLATE__ from './card-metadata.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */
import templateOnlyComponent from '@ember/component/template-only';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import type Admin from 'embercom/models/admin';

interface Args {
  icon: InterfaceIconName;
  contentTypeName: string;
  updatedAt?: string | Date;
  lastUpdatedBy?: Admin;
}

const CardMetadata = templateOnlyComponent<Args>();
export default CardMetadata;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::SideBySideReview::CardMetadata': typeof CardMetadata;
    'knowledge-hub/content-editor/side-by-side-review/card-metadata': typeof CardMetadata;
  }
}
